import BonusBalance from './BonusBalance'
export default BonusBalance



// WEBPACK FOOTER //
// ./src/atoms/BonusBalance/index.js